"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.data = [
    {
        date: '2019-01-15',
        driverId: 1,
        id: 1,
        subcontractorId: 1,
    },
];
